import React from "react";
import TiCardThreatNameAdditionalInformation from "./TiCardThreatNameAdditionalInformation";
import TiCardActorAdditionalInformation from "./TiCardActorAdditionalInformation";
import { route } from "../../../../../../shim/jsbridge";
import {
  AdditionalInformationState,
  AdditionalInformationType
} from "./@ŧypes/TiCardAdditionalInformationReducer";

const getActorRoute = (actor: string) =>
  route("search", {}, { q: `actor:"${actor}"` });

const getThreatRoute = (threat: string) =>
  route("search", {}, { q: `threatname:"${threat}"` });

type Props = {
  state: AdditionalInformationState;
  closeDetails: () => void;
};

const TiCardAdditionalInformation = ({ state, closeDetails }: Props) => (
  <>
    {state.type === AdditionalInformationType.Threat && (
      <TiCardThreatNameAdditionalInformation
        data={state.data}
        closeDetails={closeDetails}
        seeRelatedSamplesRoute={
          state.data.threat_name && getThreatRoute(state.data.threat_name)
        }
      />
    )}
    {state.type === AdditionalInformationType.Actor && (
      <TiCardActorAdditionalInformation
        actorData={state.data}
        closeDetails={closeDetails}
        seeRelatedSamplesRoute={
          state.data.name && getActorRoute(state.data.name)
        }
      />
    )}
  </>
);

export default TiCardAdditionalInformation;
